import { createAction, props } from '@ngrx/store';
import { Product } from './product.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records product'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records product success', 
    props<{ listData: Product }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records product failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state product',
);